<!--Mobile Nav-->
<fgb-page-header [pageTitle]="'faq.page.title'" [showBalance]="false"></fgb-page-header>

<div class="container">
  <fgbcl-faq-section></fgbcl-faq-section>
</div>
